import {numberSeparator,toEnglishNumber,toPersianNumber,} from "@/hooks/useThousandsSeparator";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";

type ContentProps = {
  setAmountState: any;
  amountState: any;
};
/**
ContentModal

کامپوننت مودال افزایش موجودی هدیه که به کاربر امکان وارد کردن مبلغ و توضیحات را می‌دهد.
ویژگی‌ها:
دریافت و تنظیم مقدار مبلغ شارژ از طریق props:
amountState: مقدار فعلی مبلغ ورودی
setAmountState: تابع به‌روزرسانی مقدار مبلغ
نمایش توضیحات اولیه برای راهنمایی پذیرنده درباره فرآیند افزایش موجودی هدیه.
ورودی مبلغ شارژ:
نمایش مقدار با فرمت هزارگان و تبدیل به عدد فارسی.
تبدیل ورودی کاربر به عدد انگلیسی و حذف کاراکترهای غیرعددی.
جلوگیری از ورود عدد بزرگ‌تر از ۵,۰۰۰,۰۰۰,۰۰۰,۰۰۰.
افزودن پسوند «ریال» با InputAdornment.
ریسپانسیو: در موبایل 100٪ عرض و در دسکتاپ 60٪ عرض.
نمایش مبلغ قابل پرداخت برای تعداد ثابت کارت‌ها (۲۰ کارت) با تبدیل عدد به فارسی.
ورودی توضیحات:
پشتیبانی از مقدار متنی آزاد.
ریسپانسیو: عرض 100٪ در موبایل و 55٪ در دسکتاپ.
استفاده از StackKit جهت چیدمان و TypoGraphyKit برای نمایش متون.
استفاده از Grid با overflow hidden برای کنترل اسکرول.
@param {Object} props
@param {string | number} props.amountState مقدار ورودی مبلغ
@param {(value: any) => void} props.setAmountState تابع به‌روزرسانی مبلغ
@returns JSX.Element
*/

const ContentModal = (props: ContentProps) => {
  const { amountState, setAmountState } = props;
  const [description, setDescription] = useState("");

  return (
    <Grid container sx={{ overflow: "hidden" }}>
      <StackKit>
        <TypoGraphyKit variant="body1">پذیرنده گرامی</TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          در این بخش شما میتوانید مبلغ مورد نظر خود را جهت افزایش موجودی هدیه
          وارد کنید.
        </TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          پس از وارد کردن مبلغ مورد نظر جهت شارژ ؛ مبلغ قابل پرداخت شما برای{" "}
          {toPersianNumber(20)}
          کارت به شما اعلام میگردد. شما میتوانید از طریق درگاه و یا از طریق کیف
          پول نقدی خود مبلغ اعلام شده را پرداخت نمایید.
        </TypoGraphyKit>
        <TypoGraphyKit variant="body1">
          پس از پرداخت مبلغ اعلام شده؛ موجودی هدیه شما شارژ خواهد شد.
        </TypoGraphyKit>
        <StackKit direction={{xs:'column',sm:"row"}} justifyContent={"space-between"}>
          <TypoGraphyKit variant="body1">
            مبلغ مورد نظر جهت شارژ را وارد نمایید
          </TypoGraphyKit>
          <TextField
            sx={{ width: {xs:'100%',sm:'60%'} }}
            placeholder={`${numberSeparator(200000)}`}
            value={amountState ? `${toPersianNumber(numberSeparator(amountState))}` : ""}
            onChange={(e) => {
              const englishNumber = toEnglishNumber(e.target.value);
              const rawValue = englishNumber.replace(/[^0-9]/g, "");
              if (Number(rawValue) <= 5000000000000) {
                setAmountState(rawValue);
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">ریال</InputAdornment>
              ),
            }}
          />
        </StackKit>
        <StackKit direction={{xs:'column',sm:"row"}} justifyContent={"space-between"}>
          <TypoGraphyKit variant="body1">
            مبلغ قابل پرداخت شما در {toPersianNumber(20)} کارت{" "}
          </TypoGraphyKit>
        </StackKit>
        <StackKit  direction={{xs:'column',sm:"row"}} justifyContent={"space-between"}>
          <TypoGraphyKit variant="body1" sx={{ minWidth: "200px", marginTop: "50px" }}>
            توضیحات{" "}
          </TypoGraphyKit>
          <TextField sx={{ width: {xs:'100%',sm:'55%'} }} placeholder={`متن توضیحات`} value={description}
            onChange={(e) => {
              const rawValue = e.target.value;
              setDescription(rawValue);
            }}
          />
        </StackKit>
      </StackKit>
    </Grid>
  );
};

export default ContentModal;
